// extracted by mini-css-extract-plugin
export default {"news":"News_news__goMgi","item":"News_item__q-H9F","date":"News_date__tvEfc","desc":"News_desc__tezhG"};